<div class="genre-category" routerLink="catalog/{{ genre.id }}">
  <img loading="lazy" [src]="getCover(genre.title) | bmAssetUrl" alt="{{ genre.title }}  cover" />
  <p>{{ genre.title }}</p>
</div>

<div style="margin-bottom: 7px">
  <p class="common-bmstv-title-1">{{ genre.title }}</p>
</div>
<p class="common-bmstv-title-2 common-bmstv-title-2--without-hover">{{ genre.beatsCount }} beats</p>
